import { createRouter, createWebHashHistory } from 'vue-router'

import InitRouter from '@/layouts/router'
import AuthRouter from '@/views/auth/router'
import BancoRouter from '@/views/Maestros/Otros/Banco/router'
import CampoRouter from '@/views/Maestros/Hacienda/Campo/router'
import CalidadRouter from '@/views/Maestros/Hacienda/Calidad/router'
import CategoriaRouter from '@/views/Maestros/Otros/Categoria/router'
import ColorPelajeRouter from '@/views/Maestros/Hacienda/Color_Pelaje/router'
import CategoriaPersonalRouter from '@/views/Maestros/Otros/Categoria_Personal/router'
import CategoriaProveedorRouter from '@/views/Maestros/Otros/Categoria_Proveedor/router'
import ClasificacionCaravanaRouter from '@/views/Maestros/Hacienda/Clasificacion_Caravana/router'
import CondicionCorporalRouter from '@/views/Maestros/Hacienda/Condicion_Corporal/router'
import DashboardRouter from '@/views/Dashboard/router'
import DepositoRouter from '@/views/Maestros/Insumos/Deposito/router'
import DicoseRouter from '@/views/Maestros/Hacienda/Dicose/router'
import EgresoCombustibleRouter from '@/views/Administracion/Egreso_Combustible/router'
import ErrorRouter from '@/views/error/router'
import EventoRouter from '@/views/Maestros/Hacienda/Evento/router'
import HomogeneidadRouter from '@/views/Maestros/Hacienda/Homogeneidad/router'
import InsumoRouter from '@/views/Maestros/Insumos/Insumo/router'
import InsumoComercialRouter from '@/views/Maestros/Insumos/Insumo_Comercial/router'
import MonedaRouter from '@/views/Maestros/Otros/Moneda/router'
import RazaRouter from '@/views/Maestros/Hacienda/Raza/router'
import SectorRouter from '@/views/Maestros/Hacienda/Sector/router'
import TipoActividadRouter from '@/views/Maestros/Hacienda/Tipo_Actividad/router'
import TipoProveedorRouter from '@/views/Maestros/Otros/Tipo_Proveedor/router'
import VehiculoRouter from '@/views/Maestros/Otros/Vehiculo/router'
import PersonalRouter from '@/views/Maestros/Otros/Personal/router'
import InsumoUsoRouter from '@/views/Maestros/Insumos/Insumo_Uso/router'
import RubroRouter from '@/views/Maestros/Insumos/Rubro/router'
import PruebaRouter from '@/views/prueba/router'
import GrillaRouter from '@/views/Grilla/router'
import LocalidadRouter from '@/views/Maestros/Otros/Localidad/router'
import PlandeCuentaRouter from '@/views/Maestros/Otros/Plan_de_Cuenta/router'
import PadreRouter from '@/views/Maestros/Hacienda/Padre/router'
import MotivoComederoRouter from '@/views/Maestros/Hacienda/Motivo_Comedero/router'
import ClasificacionContableRouter from '@/views/Maestros/Otros/Clasificacion_Contable/router'
import TarifarioRouter from '@/views/Maestros/Otros/Tarifario/router'
import DiagnosticoRouter from '@/views/Maestros/Hacienda/Diagnostico/router'
import OrigenRouter from '@/views/Maestros/Hacienda/Origen/router'
import TipoRacionRouter from '@/views/Maestros/Insumos/Tipo_Racion/router'
import UnidadMedidaRouter from '@/views/Maestros/Insumos/Unidad_Medida/router'
import ClasificacionCorralRouter from '@/views/Maestros/Hacienda/Clasificacion_Corral/router'
import CondicionPagoRouter from '@/views/Maestros/Otros/Condicion_Pago/router'
import EstadoTropaRouter from '@/views/Maestros/Hacienda/Estado_Tropa/router'
import ParametroContableRouter from '@/views/Maestros/Otros/Parametro_Contable/router'
import MotivoBajaCabezaRouter from '@/views/Maestros/Hacienda/Motivo_Baja_Cabeza/router'
import TipoOperacionRouter from '@/views/Maestros/Hacienda/Tipo_Operacion/router'
import CodigoAfipRouter from '@/views/Maestros/Otros/Codigo_Afip/router'
import HoteleroRouter from '@/views/Maestros/Hacienda/Hotelero/router'
import TipoComprobanteRouter from '@/views/Maestros/Otros/Tipo_Comprobante/router'
import ProveedorRouter from '@/views/Maestros/Otros/Proveedor/router'
import RenspaRouter from '@/views/Maestros/Hacienda/Renspa/router'
import PrescripcionRouter from '@/views/Alimentacion_Sanidad/Prescripcion/router'
import PrescripcionMobileRouter from '@/views/Alimentacion_Sanidad/PrescripcionMobile/router'

//import PrescripcionRouter from '@/views/Prescripcion/router'
import CorralRouter from '@/views/Maestros/Hacienda/Corral/router'
import MotivoRouter from '@/views/Maestros/Otros/Motivo/router'
import TipoContriRouter from '@/views/Maestros/Otros/Tipo_Contribuyente/router'
import ClasificacionSanidadRouter from '@/views/Maestros/Hacienda/Clasificacion_Sanidad/router'
import TipoValorRouter from '@/views/Maestros/Otros/Tipo_Valor/router'
import GastoFijoRouter from '@/views/Maestros/Insumos/Gasto_Fijo/router'
import ProvinciaRouter from '@/views/Maestros/Otros/Provincia/router'
import PrecioSugeridoRouter from '@/views/Administracion/Precio_Sugerido/router'
import CargarMateriaSecaInsumoRouter from '@/views/Administracion/Cargar_Materia_Seca_Insumo/router'
import ReformularRacionRouter from '@/views/Administracion/Reformular_Racion/router'

import TipoCambioRouter from '@/views/Administracion/Tipo_Cambio/router'
import TiempoRouter from '@/views/Administracion/Tiempo/router'
import RacionRouter from '@/views/Maestros/Insumos/Racion/router'
import ParametroEngordeRouter from '@/views/Parametros/Parametro_Engorde/router'
import RacionMateriaSecaRouter from '@/views/Administracion/Racion_Materia_Seca/router'
import MermaHumedadRouter from '@/views/Maestros/Insumos/Merma_Humedad/router'
import ParametroEngordeRacionRouter from '@/views/Parametros/Parametro_Engorde_Racion/router'
import RelaCorralCuotaRouter from '@/views/Maestros/Hacienda/Rela_Corral_Cuota/router'
import RecorridoDefaultRouter from '@/views/Maestros/Hacienda/Recorrido_Default/router'
import LecturaComederoRouter from '@/views/Alimentacion_Sanidad/Lectura_Comedero/router'
import RacionHumedadRouter from '@/views/Maestros/Insumos/Racion_Humedad/router'
import RangoPesoEstadiaRouter from '@/views/Parametros/Rango_Peso_Estadia/router'
import GastoEstructuraRouter from '@/views/Comprobantes/Gasto_Estructura/router'
import ProtocoloRouter from '@/views/Maestros/Insumos/Protocolo/router'
import CargaStockDiarioRouter from '@/views/Hacienda/Carga_Stock_Diario/router'
import RegimenRouter from '@/views/Contables/Regimen/router'
import EjercicioContableRouter from '@/views/Maestros/Otros/Ejercicio_Contable/router'
import ParteNovedadRouter from '@/views/Administracion/Parte_Novedad/router'
import ParteIngresosRouter from '@/views/Administracion/Parte_Ingresos/router'
import IngresoInsumoRouter from '@/views/Administracion/Ingreso_Insumo/router'
import EgresoInsumoRouter from '@/views/Administracion/Egreso_Insumo/router'
import LstPlanillaCorralRouter from '@/views/Listados/Planilla_Uso_Diario/Lst_Planilla_Corral/router'
import LstPlanillaRecorridoRouter from '@/views/Listados/Planilla_Uso_Diario/Lst_Planilla_Recorrido/router'
import LstAnalisisRepartoCorralRouter from '@/views/Listados/Planilla_Uso_Diario/Analisis_Reparto_Corral/router'
import LstAnalisisRepartoCorralRouterV2 from '@/views/Listados/Planilla_Uso_Diario/Analisis_Reparto_CorralV2/router'
import LstAnalisisFeedlot from '@/views/Listados/Analisis/Lst_Analisis_Feedlot/router'

import CambioCorralRouter from '@/views/Hacienda/Cambio_corral/router'

import LstInsumoRepartidoRouter from '@/views/Listados/Stock/Lst_Insumo_Repartido/router'

import BajaCabezaRouter from '@/views/Hacienda/Baja_Cabeza_noUsar/router'
import BajaCabezaRfidRouter from '@/views/Hacienda/Baja_Cabeza_RFID/router'

import WinMangaRouter from '@/views/WinManga/router'

import ChangeInsumoRouter from '@/views/Alimentacion_Sanidad/Change_Insumo/router'
import ContratoRouter from '@/views/Administracion/Contrato/router'
import StockInsumoHistoricoRouter from '@/views/Administracion/Stock_Insumo_Historico/router'
import CabGastoTropaRouter from '@/views/Administracion/Cab_Gasto_Tropa/router'
import AdmMixerRouter from '@/views/Alimentacion_Sanidad/Carga_Mixer/router'
import ComprobanteHaciendaRouter from '@/views/Comprobantes/Comprobante_Hacienda/router'
import ComprobanteHaciendaPruebaRouter from '@/views/prueba/Comprobante_Hacienda_Prueba/router'
import Camion from '@/views/Administracion/Camion/router'
import RindePorDestinoRouter from '@/views/Maestros/Hacienda/Rinde_Por_Destino/router'
import EquipoWmRouter from '@/views/Maestros/Hacienda/Equipo_Wm/router'
import ModuloRouter from '@/views/Maestros/Hacienda/Modulo/router'
import Adm_SanidadRouter from '@/views/Alimentacion_Sanidad/Adm_Sanidad/router'
import Control_AlertaRouter from '@/views/Parametros/Control_Alerta/router'


// Renombrar el Router
import Pesada_CorralRouter from '@/views/Hacienda/Pesada_Por_Corral/router'

import Ctrl_Peso_DiarioRouter from '@/views/Hacienda/Ctrl_Peso_Diario/router'
import Agrupa_TropaRouter from '@/views/Hacienda/Agrupa_Tropa/router'
import Cambio_CategoriaRouter from '@/views/Hacienda/Cambio_Categoria_Tropa/router'
import Estado_SanitarioRouter from '@/views/Maestros/Hacienda/Estado_Sanitario/router'
import Tiempo_AlimentacionRouter from '@/views/Maestros/Hacienda/Tiempo_Alimentacion/router'


// @/views/Manejo_Caravanas
import ConsultaCaravanaRouter from '@/views/Manejo_Caravanas/Consulta_Caravana/router'

import CC_PesadaRouter from '@/views/Manejo_Caravanas/CC_Pesada/router'
import Cambio_Categoria_CaravanaRouter from '@/views/Manejo_Caravanas/Cambio_Categoria_Caravana/router'
import Actualiza_CaravanaRouter from '@/views/Manejo_Caravanas/Actualiza_Caravana/router'
import Validar_CaravanaRouter from '@/views/Manejo_Caravanas/Validar_Caravana/router'

import ProduccionRouter from '@/views/Alimentacion_Sanidad/Produccion/router'
import GraficoConsumoCorralViejoRouter from '@/views/Listados/Planilla_Uso_Diario/Grafico_Consumo_Corral/router'
import GraficoConsumoCorralRouter from '@/views/graficos/Grafico_Consumo_Corral/router'
import GraficoConsumoCorralComponentRouter from '@/views/Componente/GraficoConsumoCorral/router'
import OtroGrafico from '@/views/graficos/Grafico_Carga_Descarga/router'
import Ingreso_HaciendaRouter from '@/views/Hacienda/Ingreso_Hacienda/router'
import ComprobanteVariosRouter from '@/views/Comprobantes/Comprobante_Varios/router'
import Dar_Vuelta_CierreRouter from '@/views/Procesos/Otros_Procesos/Dar_Vuelta_Cierre/router'
import Racion_AutoconsumoRouter from '@/views/Alimentacion_Sanidad/Racion_Autoconsumo/router'
import Agenda_RacionRouter from '@/views/Alimentacion_Sanidad/Agenda_Racion/router'
import LstComprobanteRouter from '@/views/Listados/Comprobantes/Lst_Comprobante/router'

import LstStockInsumoRouter from '@/views/Listados/Planilla_Uso_Diario/Lst_Stock_Insumo/router'
import Lst_Resultado_TropaRouter from '@/views/Listados/Analisis/Lst_Resultado_Tropa/router'
import LstStockHaciendaRouter from '@/views/Listados/Planilla_Uso_Diario/Lst_Stock_Hacienda/router'
import LstMovimientoHaciendaRouter from '@/views/Listados/Planilla_Uso_Diario/LstMovimientoHacienda/router'

import graficoStockHacienda from '@/views/graficos/Grafico_Stock_Hacienda/router'
import grafico_stock_caravanas from '@/views/graficos/Caravana_Stock/router'
import agenda_sanidad from '@/views/graficos/Agenda_Sanidad/router'
import Dashboard_Agendas from '@/views/graficos/Dashboard_Agendas/router'


import BalanzaMixer from '@/views/BalanzaMixer/router'

import ControlAccesos from '@/views/Control_Accesos/router'
import Parametros from '@/views/Parametros/Generales/router'
import graficoMapa from '@/views/graficos/Grafico_Mapa/router'
import PrsentacionDeMapa from '@/views/graficos/Presentacion_De_Mapa/router'
import PresentacionMapaActividad from '@/views/graficos/Grafico_Actividad/router'
import graficoDetalleInsumos from '@/views/graficos/Grafico_Detalle_Insumos/router'

import Lst_Detalle_Minuta from '@/views/Listados/Comprobantes/Lst_Detalle_Minuta/router'
import Lst_Minuta from '@/views/Listados/Hacienda/Lst_Minuta/router'
import Evolucion_Precios from '@/views/Listados/Comprobantes/Evolucion_Precios/router'
import InstalarWC from '@/views/Sistemas/InstalarWC/router'
import ImportaWcRouter from '@/views/Sistemas/ImportaWC/router'


import Lst_Informe_Gestion from '@/views/Listados/Hacienda/Lst_Informe_Gestion/router'
import Lst_Sanidad from '@/views/Listados/Hacienda/Lst_Sanidad/router'
import Lst_Egresos_Hacienda from '@/views/Listados/Hacienda/Lst_Egresos_Hacienda/router'
import Lst_Lotes_WinManga from '@/views/Listados/Planilla_Uso_Diario/Lst_Lotes_WinManga/router'
import Mail_Gordos from '@/views/Listados/Hacienda/Mail_Gordos/router'
import Lst_Pago_Cobro from '@/views/Listados/Comprobantes/Lst_Pago_Cobro/router'
import Lst_481 from '@/views/Listados/Hacienda/Lst481/router'
import Registro_Descuento from '@/views/Alimentacion_Sanidad/Registro_Descuento/router'
import Lst_Estadistica from '@/views/Listados/Hacienda/Lst_Estadistica/router'
import Lst_Trazabilidad from '@/views/Listados/Hacienda/Lst_Trazabilidad/router'
import Lst_Parte_Ingreso from '@/views/Listados/Planilla_Uso_Diario/Lst_Parte_Ingreso/router'
import EscalaRouter from '@/views/Contables/Escala/router'
import ImportaFaena from '@/views/Manejo_Caravanas/Importa_Faena/router'
import ConsultaCTACTE from '@/views/Proveedor_Cliente/Otros_Procesos/Consulta_CtaCte/router'
import InsumoCosto from '@/views/Administracion/Costea_Consumo/router'
import PagoCobro from '@/views/Proveedor_Cliente/Otros_Procesos/Pago_Cobro/router'
import EstadoDocumentacionRouter from '@/views/Maestros/Otros/Estado_Documentacion/router'
import Lst_Analisis_Consumo from '@/views/Listados/Hacienda/Lst_Analisis_Consumo/router'
import Lst_Saldo from '@/views/Proveedor_Cliente/Otros_Procesos/Lst_Saldo/router'
import ControlGeneralRouter from '@/views/Mantenimiento_Sofware/Control_General/router'
import Tablero_AlertasRouter from '@/views/Mantenimiento_Sofware/Tablero_Alertas/router'

import Lst_Evolucion_Feedlot from '@/views/Listados/Analisis/Lst_Evolucion_Feedlot/router' 
import KioskMapaFeedlotRouter from '@/views/Kiosk/router'
import CierreHoteleria from '@/views/Administracion/Cierre_Hoteleria/router'
import Importa_PadronRouter from '@/views/Contables/Importa_Padron/router'
import Nov_FinnegansRouter from '@/views/Procesos/Otros_Procesos/Nov_Finnegans/router'
import Nov_PhysisRouter from '@/views/Procesos/Otros_Procesos/Nov_Physis/router'
import Importa_Comprobante from '@/views/Comprobantes/Importa_Comprobante/router'
import WC_2_APPRouter from '@/views/Parametros/WC_2_APP/router'
import Notificaciones_AutomaticasRouter from '@/views/Parametros/Notificaciones_Automaticas/router'
import Ejecuta_SQLRouter from '@/views/Mantenimiento_Sofware/Ejecuta_SQL/router'
import Nov_SapRouter from '@/views/Procesos/Otros_Procesos/Nov_Sap/router'
import Presupuesto_EngordeRouter from '@/views/Listados/Hacienda/Presupuesto_Engorde/router'

import AlborRouter from '@/views/Parametros/Albor/router'

var allRoutes = []
allRoutes = allRoutes.concat(
  InitRouter,
  AuthRouter,
  BancoRouter,
  CampoRouter,
  CalidadRouter,
  CategoriaRouter,
  CategoriaPersonalRouter,
  CategoriaProveedorRouter,
  ClasificacionCaravanaRouter,
  CondicionCorporalRouter,
  ColorPelajeRouter,
  CorralRouter,
  DashboardRouter,
  DepositoRouter,
  DicoseRouter,
  EgresoCombustibleRouter,
  EventoRouter,
  HomogeneidadRouter,
  InsumoRouter,
  InsumoComercialRouter,
  MonedaRouter,
  RazaRouter,
  SectorRouter,
  TipoActividadRouter,
  TipoProveedorRouter,
  TipoRacionRouter,
  VehiculoRouter,
  PersonalRouter,
  InsumoUsoRouter,
  PruebaRouter,
  LocalidadRouter,
  RubroRouter,
  PlandeCuentaRouter,
  PadreRouter,
  MotivoComederoRouter,
  ClasificacionContableRouter,
  TarifarioRouter,
  DiagnosticoRouter,
  OrigenRouter,
  UnidadMedidaRouter,
  CondicionPagoRouter,
  ClasificacionCorralRouter,
  EstadoTropaRouter,
  ParametroContableRouter,
  RenspaRouter,
  MotivoBajaCabezaRouter,
  CodigoAfipRouter,
  TipoOperacionRouter,
  PrescripcionRouter,
  MotivoRouter,
  HoteleroRouter,
  TipoComprobanteRouter,
  TipoContriRouter,
  ProveedorRouter,
  ClasificacionSanidadRouter,
  GastoFijoRouter,
  TipoValorRouter,
  TiempoRouter,
  ProvinciaRouter,
  PrecioSugeridoRouter,
  CargarMateriaSecaInsumoRouter,
  RacionRouter,
  TipoCambioRouter,
  ParametroEngordeRouter,
  RacionMateriaSecaRouter,
  MermaHumedadRouter,
  ParametroEngordeRacionRouter,
  RelaCorralCuotaRouter,
  RecorridoDefaultRouter,
  LecturaComederoRouter,
  RacionHumedadRouter,
  RangoPesoEstadiaRouter,
  GastoEstructuraRouter,
  ProtocoloRouter,
  CargaStockDiarioRouter,
  RegimenRouter,
  EjercicioContableRouter,
  ParteNovedadRouter,
  ParteIngresosRouter,
  IngresoInsumoRouter,
  EgresoInsumoRouter,
  LstPlanillaCorralRouter,
  //ConfiguracionReporteRouter,
  ChangeInsumoRouter,
  CambioCorralRouter,
  ConsultaCaravanaRouter,
  GrillaRouter,
  LstPlanillaRecorridoRouter,
  ContratoRouter,
  StockInsumoHistoricoRouter,
  CabGastoTropaRouter,
  AdmMixerRouter,
  ComprobanteHaciendaRouter,
  ComprobanteHaciendaPruebaRouter,
  Camion,
  RindePorDestinoRouter,
  EquipoWmRouter,
  ModuloRouter,
  Adm_SanidadRouter,
  Control_AlertaRouter,
  Cambio_CategoriaRouter,
  Pesada_CorralRouter,
  Ctrl_Peso_DiarioRouter,
  Validar_CaravanaRouter,
  CC_PesadaRouter,
  Cambio_Categoria_CaravanaRouter,
  BajaCabezaRouter,
  BajaCabezaRfidRouter,
  Actualiza_CaravanaRouter,
  Agrupa_TropaRouter,
  ProduccionRouter,
  Ingreso_HaciendaRouter,
  GraficoConsumoCorralViejoRouter,
  GraficoConsumoCorralRouter,
  GraficoConsumoCorralComponentRouter,
  Estado_SanitarioRouter,
  Tiempo_AlimentacionRouter,
  ComprobanteVariosRouter,
  Dar_Vuelta_CierreRouter,
  Racion_AutoconsumoRouter,
  Agenda_RacionRouter,
  LstAnalisisRepartoCorralRouter,
  LstAnalisisRepartoCorralRouterV2,
  LstStockInsumoRouter,
  OtroGrafico,
  LstInsumoRepartidoRouter,
  Lst_Resultado_TropaRouter,
  LstStockHaciendaRouter,
  graficoStockHacienda,
  LstMovimientoHaciendaRouter,
  LstComprobanteRouter,
  BalanzaMixer,
  ControlAccesos,
  Parametros,
  graficoMapa,
  PrsentacionDeMapa,
  graficoDetalleInsumos,
  LstAnalisisFeedlot,
  Lst_Detalle_Minuta,
  Evolucion_Precios,
  Lst_Sanidad,
  Lst_Egresos_Hacienda,
  Lst_Lotes_WinManga,
  Mail_Gordos,
  Lst_Pago_Cobro,
  Lst_481,
  Registro_Descuento,
  Lst_Estadistica,
  Lst_Trazabilidad,
  Lst_Parte_Ingreso,
  PresentacionMapaActividad,
  EscalaRouter,
  ImportaFaena,
  ConsultaCTACTE,
  Lst_Informe_Gestion,
  InsumoCosto,
  PagoCobro,
  EstadoDocumentacionRouter,
  Lst_Analisis_Consumo,
  Lst_Saldo,
  ControlGeneralRouter,
  Lst_Evolucion_Feedlot, 
  Lst_Minuta,
  KioskMapaFeedlotRouter,
  CierreHoteleria,
  ReformularRacionRouter,
  Importa_PadronRouter,
  Nov_FinnegansRouter,
  Importa_Comprobante,
  WC_2_APPRouter,
  Notificaciones_AutomaticasRouter,
  Ejecuta_SQLRouter,
  InstalarWC,
  ImportaWcRouter,
  Nov_SapRouter,
  Presupuesto_EngordeRouter,
  grafico_stock_caravanas,
  WinMangaRouter,
  agenda_sanidad,
  Tablero_AlertasRouter,
  PrescripcionMobileRouter,
  Nov_PhysisRouter,
  AlborRouter, 
  Dashboard_Agendas,
  // ErrorRouter tiene que ir ultimo....
  ErrorRouter,
)

const router = createRouter({
  history: createWebHashHistory(),
  routes: allRoutes,
  scrollBehavior() {
    return { top: 0 }
  },
})

export default router
